module.exports = __webpack_public_path__ + "static/media/duplicate.2dfdf0dc.svg";